import React, { useState } from "react";
import "../css/SchoolInfrastructure.css";

const SchoolInfrastructure = () => {
  const [activeShift, setActiveShift] = useState("morning");

  const morningInfrastructure = [
    {
      slNo: 1,
      info: "Total Campus Area of the School (In Sq. Mtrs.)",
      details: "11,776 Sq. Mtrs.",
    },
    {
      slNo: 2,
      info: "No. And Size of Classrooms (In Sq. Ft. Mtrs.)",
      details: "58 | 587.5 / 52.6875",
    },
    {
      slNo: 3,
      info: "No. And Size of Laboratories including Computer Labs (In Sq. Mtrs.)",
      details: "16 | 102.456",
    },
    {
      slNo: 4,
      info: "Internet Facility",
      details: "Yes",
    },
    {
      slNo: 5,
      info: "No. of Girls Toilets",
      details: "46",
    },
    {
      slNo: 6,
      info: "No. of Boys Toilets",
      details: "42",
    },
  ];

  const afternoonInfrastructure = [
    {
      slNo: 1,
      info: "Total Campus Area of the School (In Sq. Mtrs.)",
      details: "11,776 Sq. Mtrs.",
    },
    {
      slNo: 2,
      info: "No. And Size of Classrooms (In Sq. Ft. Mtrs.)",
      details: "52 | 587.5 / 52.6875",
    },
    {
      slNo: 3,
      info: "No. And Size of Laboratories including Computer Labs (In Sq. Mtrs.)",
      details: "14 | 102.456",
    },
    {
      slNo: 4,
      info: "Internet Facility",
      details: "Yes",
    },
    {
      slNo: 5,
      info: "No. of Girls Toilets",
      details: "46",
    },
    {
      slNo: 6,
      info: "No. of Boys Toilets",
      details: "42",
    },
  ];

  const currentData =
    activeShift === "morning"
      ? morningInfrastructure
      : afternoonInfrastructure;

  return (
    <section className="infra-section section">
      <div className="container">
        <div className="infra-header">
          <span className="eyebrow">
            SCHOOL FACILITIES
          </span>

          <h2>
            School Infrastructure
          </h2>

          <p className="text-lead">
            Explore our modern classrooms, laboratories and campus facilities
            designed to provide students with a safe, comfortable and inspiring
            learning environment.
          </p>
        </div>

        <div className="infra-tabs">
          <button
            type="button"
            className={`btn ${
              activeShift === "morning"
                ? "btn-primary"
                : "btn-outline"
            }`}
            onClick={() => setActiveShift("morning")}
          >
            Morning Shift
          </button>

          <button
            type="button"
            className={`btn ${
              activeShift === "afternoon"
                ? "btn-primary"
                : "btn-outline"
            }`}
            onClick={() => setActiveShift("afternoon")}
          >
            Afternoon Shift
          </button>
        </div>

        <div className="infra-table-wrapper">
          <table className="infra-table">
            <thead>
              <tr>
                <th className="col-sl">SL No.</th>
                <th className="col-info">Information</th>
                <th className="col-details">Details</th>
              </tr>
            </thead>

            <tbody>
              {currentData.map((row) => (
                <tr key={row.slNo}>
                  <td>{row.slNo}</td>
                  <td>{row.info}</td>
                  <td>{row.details}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default SchoolInfrastructure;